import React from 'react';
import {
  Box, Flex, Icon, Text, useColorModeValue, useDisclosure,
  Drawer, DrawerOverlay, DrawerContent, DrawerBody, SimpleGrid,
} from '@chakra-ui/react';
import { FaEllipsisH } from 'react-icons/fa';
import { IconType } from 'react-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { navPrincipais, navSecundarios, ativo } from './navItems';

// Altura da barra, sem contar a área segura do iPhone. O App usa para
// reservar espaço no fim da página
export const ALTURA_BOTTOM_NAV = '60px';

const ItemBarra: React.FC<{ label: string; icon: IconType; selecionado: boolean; onClick: () => void }> = ({ label, icon, selecionado, onClick }) => {
  const cor = useColorModeValue(selecionado ? 'teal.600' : 'gray.500', selecionado ? 'teal.300' : 'gray.400');
  return (
    <Flex
      as="button"
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-current={selecionado ? 'page' : undefined}
      direction="column"
      align="center"
      justify="center"
      flex="1"
      minW={0}
      h={ALTURA_BOTTOM_NAV}
      gap="3px"
      color={cor}
      _active={{ bg: 'blackAlpha.50' }}
    >
      <Icon as={icon as any} boxSize={5} />
      <Text fontSize="11px" fontWeight={selecionado ? 700 : 500} lineHeight="1" noOfLines={1}>
        {label}
      </Text>
    </Flex>
  );
};

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const mais = useDisclosure();
  const bg = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.200', 'gray.700');
  const cardBg = useColorModeValue('gray.50', 'gray.700');
  const emMais = navSecundarios.some(i => ativo(i, pathname));

  const ir = (path: string) => {
    mais.onClose();
    navigate(path);
  };

  return (
    <Box
      as="nav"
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      zIndex="sticky"
      bg={bg}
      borderTopWidth="1px"
      borderColor={border}
      boxShadow="0 -2px 8px rgba(0,0,0,0.05)"
      display={{ base: 'block', md: 'none' }}
      pb="env(safe-area-inset-bottom)"
    >
      <Flex>
        {navPrincipais.map(item => (
          <ItemBarra key={item.path} label={item.label} icon={item.icon} selecionado={ativo(item, pathname)} onClick={() => ir(item.path)} />
        ))}
        <ItemBarra label="Mais" icon={FaEllipsisH} selecionado={emMais || mais.isOpen} onClick={mais.isOpen ? mais.onClose : mais.onOpen} />
      </Flex>

      <Drawer placement="bottom" isOpen={mais.isOpen} onClose={mais.onClose}>
        <DrawerOverlay />
        <DrawerContent borderTopRadius="2xl" pb="calc(16px + env(safe-area-inset-bottom))">
          <DrawerBody pt={3} px={4}>
            <Box w="40px" h="4px" bg="gray.300" borderRadius="full" mx="auto" mb={4} />
            <SimpleGrid columns={2} spacing={3}>
              {navSecundarios.map(item => {
                const sel = ativo(item, pathname);
                return (
                  <Flex
                    key={item.path}
                    as="button"
                    type="button"
                    onClick={() => ir(item.path)}
                    align="center"
                    gap={3}
                    p={4}
                    borderRadius="xl"
                    bg={sel ? 'teal.50' : cardBg}
                    color={sel ? 'teal.700' : undefined}
                    borderWidth="1px"
                    borderColor={sel ? 'teal.200' : 'transparent'}
                    fontWeight={600}
                  >
                    <Icon as={item.icon as any} boxSize={5} color={sel ? 'teal.600' : 'gray.500'} />
                    {item.label}
                  </Flex>
                );
              })}
            </SimpleGrid>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default BottomNav;
